// TODO: Add all report keys to this enum and replace all uses of hardcoded strings
export enum REPORT_KEYS {
  COACHING_EFFECTIVENESS = 'coaching-effectiveness',
  SPEND_SUMMARY_BY = 'spend-summary-by',
  TRANSACTIONS = 'transactions',
  CARDS_INVENTORY = 'cards-inventory',
  CATEGORY_ADJUSTABLE_TRANSACTIONS = 'category-adjustable-transactions',
  CAMERA_DETAIL = 'camera-detail',
  DISPATCH_SUMMARY = 'dispatch',
  ACTIVE_DISPATCHES = 'active-dispatches',
  FLEET_SCORE = 'weekly_company_score_report',
  GROUP_SCORE = 'weekly-group-score',
  DRIVER_SCORE = 'weekly_driver_score_report',
  COACH_PERFORMANCE = 'coach-performance',
  SAFETY_SUMMARY = 'safety-summary',
  ASSET_GATEWAY_DETAIL = 'asset-gateways-detail',
  EV_ENERGY_USAGE = 'ev-energy-usage',
  INCAB_ALERTS = 'incab-alerts',
  IFTA_TRIPS = 'ifta-trips-rearch',
  DRIVER_QUALIFICATION_DOCUMENTS = 'driver-qualification-documents',
  VEHICLE_DOCUMENTS = 'vehicle-documents',
  CAMERA_DETAIL_V2 = 'camera-detail-v2',
  AVAILABILITY_REPORT = 'availability-report',
  MAINTENANCE_REMINDER_DETAIL = 'maintenance-reminder-detail',
  MAINTENANCE_HISTORY_DETAIL = 'maintenance-history-detail',
  OPERATING_COST_MMY = 'operating-cost-by-mmy',
  OPERATING_COST_ENTITY = 'operating-cost-by-entity',
  CARB_CLEAN_TRUCK_CHECK = 'carb-clean-truck-check',
  SAFETY_SCORE_POINTS_TABLE_V2 = 'safety-score-points-table-v2',
  VEHICLE_BENCHMARK = 'vehicle-benchmark',
  DOOR_OPEN_EVENTS = 'door-open-events',
  VEHICLE_REPLACEMENT_ANALYSIS = 'vehicle-replacement-analysis',
  INVENTORY_STOCK = 'inventory_stock',
}
